import { render, staticRenderFns } from "./video-list-items.vue?vue&type=template&id=e50408ee"
import script from "./video-list-items.vue?vue&type=script&lang=js"
export * from "./video-list-items.vue?vue&type=script&lang=js"
import style0 from "./video-list-items.vue?vue&type=style&index=0&id=e50408ee&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports